import { createContext, useContext } from 'react'

/**
 * Board t5xf: the organization's `uiBlocks` flag, provided by `ProjectProvider`.
 * A context of its own because `MessageMarkdown` can render outside a project,
 * where no organization can have switched it off and the default (on) applies.
 */
export const UiBlocksFlagContext = createContext(true)

export const useUiBlocksEnabled = () => useContext(UiBlocksFlagContext)
